
import { defineComponent } from 'vue';
import { abreWhatsApp } from '@/uteis/contato';

export default defineComponent({
    name: 'ChamadaOrcamento',
    props: {
        Titulo: {
            type: String,
            default: ""
        },
        SubTitulo: {
            type: String,
            default: ""
        },
        TextoWhatsApp: {
            type: String,
            default: ""
        }
    },
    methods: {
        abrirWhatsApp() {
            abreWhatsApp(this.TextoWhatsApp, 'Faixa amarela');
        }
    }
});
